import { useCallback, useEffect, useState } from 'react';
import { useIsFocusedTab } from './useIsFocusedTab';

/**
 * 한 번이라도 tab focus를 받은 적이 있으면 true.
 * 첫 viewWillAppear가 들어온 이후로는 다른 탭으로 전환되어 isFocusedTab이 false로 떨어져도
 * 값이 true로 유지됩니다.
 *
 * 사용 사례: 스크롤 위치 등 ephemeral 상태를 유지해야 하므로 한 번 마운트된 children을
 * 다시 unmount하면 안 되는 surface.
 */
export const useHasBeenFocusedTab = () => {
  const isFocusedTab = useIsFocusedTab();
  const [hasBeenFocused, _setHasBeenFocused] = useState(false);

  const setHasBeenFocused = useCallback((next: boolean) => {
    _setHasBeenFocused(prev => {
      if (prev !== next) {
        return next;
      }
      return prev;
    });
  }, []);

  useEffect(() => {
    if (isFocusedTab) setHasBeenFocused(true);
  }, [isFocusedTab, setHasBeenFocused]);

  return { hasBeenFocused, setHasBeenFocused };
};
